export type Locale = 'en' | 'fr' | 'es' | 'pt'

export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'fr', 'es', 'pt'] as const
export const DEFAULT_LOCALE: Locale = 'en'

export type Localized<T = string> = Record<Locale, T>

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  pt: 'Português',
}

export const LOCALE_INTL_TAGS = {
  en: 'en-US',
  fr: 'fr-FR',
  es: 'es-MX',
  pt: 'pt-BR',
} as const satisfies Record<Locale, string>

export type LocaleTag = (typeof LOCALE_INTL_TAGS)[Locale]

export const LOCALE_REGION_LABELS: Record<Locale, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español (México)',
  pt: 'Português (Brasil)',
}

export function localeFlag(locale: Locale): string {
  const region = LOCALE_INTL_TAGS[locale].split('-')[1] ?? ''
  return [...region].map((c) => String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0))).join('')
}

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && SUPPORTED_LOCALES.includes(value as Locale)
}

export function localeFromTag(tag: string | null | undefined): Locale {
  const base = tag?.split('-')[0]?.toLowerCase()
  return isLocale(base) ? base : DEFAULT_LOCALE
}

export type { TranslationKey, Translations } from './locales/en'

import type { TranslationKey } from './locales/en'

export interface I18nContextValue {
  locale: () => Locale
  setLocale: (locale: Locale) => void
  t: (key: TranslationKey, params?: Record<string, string | number>) => string
  availableLocales: readonly Locale[]
}
